module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NKOasp/tc-custom/9781634865623.jpg?1723405692261",
      "alt": "This image is the cover for the book Hot Shots"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hot Shots\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Since he first laid eyes on Michael Phelps as a teenager, young Beau has longed to be an Olympian; the better to sleep with as many other Olympians as possible. Too bad he's a flop at every sport he tries."), _c('br'), _c('br'), _vm._v("An offhand reference by his European mother reveals a family connection to the world of competitive shooting, and a quick -- if not wholly truthful -- email nets Beau an invitation to Luxembourg to train with Marcel, a dashing rifle champion. He jumps at the chance, and, when he learns they aren't actually related, at the champ."), _c('br'), _c('br'), _vm._v("Sparks fly, but Beau’s never exactly been what you’d call a one-man man. Will Beau’s smoldering desire for Marcel burn hot enough to keep the torch of his Olympic dreams aflame?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael P. Thomas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michael P. Thomas is a former flight attendant whose mid-life career change to 911 operator has shown him that the widespread fear of sharing and receiving love is a real emergency. He writes to spread love and encourage others to do likewise. And a little bit to scare the gay-haters. For more information, visit facebook.com/GoReadMichaelPThomas.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0